export enum Downloadtype {
  SAMPLE_CSV = 'SAMPLE_CSV',
  MY_SERVICEBILITY = 'MY_SERVICEABILITY',
  ALL_PINCODES = 'ALL_PINCODES'
}

export enum BackendServiceabilityStatus {
  VALIDATION_SUCCESS = 'VALIDATION_SUCCESS',
  VALIDATION_FAILED = 'VALIDATION_FAILURE',
  MALFORMED_FILE_UPLOADED = 'MALFORMED_FILE_UPLOADED',
  MAX_ALLOWED_ROWS_LIMIT_BREACHED = 'MAX_ALLOWED_ROWS_LIMIT_BREACHED'
}
export interface Serviceability {
  state: string;
  district: string;
  serviceablePincodesInDistrict: string;
  serviceablePincodesInDpd1To30: string;
  serviceablePincodesInDpd31To90: string;
  serviceablePincodesInDpd90Plus: string;
}

export interface AgencySummary {
  serviceability: Serviceability[];
  pages: {
    pageNo: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
  };
}

export interface State {
  code: string;
  name: string;
}

export interface Agency {
  code: string;
  name: string;
}
